import { ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { Routes } from '@angular/router';
import { ComponentState } from '@app/models/component-state';
import { Utilities } from '@app/common/utilities';

export class ComponentsOnRoutesState {
  RouteMap: Map<string, Array<ComponentState>> = new Map<string, Array<ComponentState>>();
  MainMap = new Array<ComponentState>();

  constructor(routeConfig: Routes, componentFactoryResolver: ComponentFactoryResolver, vcr: ViewContainerRef) {
    // Iterate through components on routes
    routeConfig.forEach(route => {
      const routeKey = `/${route.path}`;
      const components = Utilities.getComponentsOnRoute(route, componentFactoryResolver, vcr);
      this.RouteMap.set(routeKey, components);
    });
  }
}
